export const compareTwo = (array1, array2) => {
    const added = [], removed = [];
    for (const id of array2) {
        if (array1.indexOf(id) < 0) added.push(id);
    }

    for (const id of array1) {
        if (array2.indexOf(id) < 0) removed.push(id);
    }

    return { added, removed };
}